export default "__VITE_ASSET__0SM2CYZi__"